import { Skeleton } from "@dash/skeleton";
import { groupSignals, SignalGroupRow, sortSignalGroups, useSignals } from "@megarax/features";
import { useMemo } from "react";
import { MdOutlineNotifications } from "react-icons/md";

import { getMegaraxPath } from "@megaron/megarax-uri";

import { SectionCard, SectionCardProps } from "./SectionCard";

const signalsLimit = 5;
const skeletonRows = [0, 1, 2, 3, 4];

const cardProps: Omit<SectionCardProps, "children"> = {
  header: "Ostatnie powiadomienia",
  linkTo: getMegaraxPath.uri("megarax://signals"),
  linkLabel: "Wszystkie",
  linkIcon: <MdOutlineNotifications />,
};

export const SignalsCard: React.FC = () => {
  const { signals, isLoading } = useSignals();

  const groups = useMemo(
    () =>
      sortSignalGroups(groupSignals(signals), { field: "createdAt", order: "DESC" }, (app) => app).slice(
        0,
        signalsLimit,
      ),
    [signals],
  );

  if (isLoading)
    return (
      <SectionCard {...cardProps}>
        <SignalsSkeleton />
      </SectionCard>
    );

  if (groups.length === 0) return null;

  return (
    <SectionCard {...cardProps}>
      <div css={{ display: "flex", flexDirection: "column", gap: "0.125rem", width: "100%" }}>
        {groups.map((group) => (
          <SignalGroupRow key={group.key} group={group} />
        ))}
      </div>
    </SectionCard>
  );
};

const SignalsSkeleton: React.FC = () => (
  <div css={{ display: "flex", flexDirection: "column", gap: "0.625rem", width: "100%" }}>
    {skeletonRows.map((row) => (
      <div key={row} css={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
        <div css={{ flex: 1, minWidth: 0 }}>
          <Skeleton width={`${75 - row * 7}%`} height="0.875rem" />
        </div>

        <Skeleton width="3.5rem" height="1rem" />
      </div>
    ))}
  </div>
);
